import { render, staticRenderFns } from "./ProductStoresStockLevels.vue?vue&type=template&id=63855bff&scoped=true"
import script from "./ProductStoresStockLevels.vue?vue&type=script&lang=js"
export * from "./ProductStoresStockLevels.vue?vue&type=script&lang=js"
import style0 from "./ProductStoresStockLevels.vue?vue&type=style&index=0&id=63855bff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63855bff",
  null
  
)

export default component.exports